module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-ae4e51bf095f0dcd42bdef47eca649ff.png";